import type { CollectionItem } from "../features/collection/state";

type CollectionViewProps = {
  readonly items: readonly CollectionItem[];
  readonly statusMessage: string | null;
};

export const CollectionView = (props: CollectionViewProps) => (
  <section className="collection-section" aria-labelledby="collection-title">
    <h1 id="collection-title">コレクション</h1>
    {props.statusMessage ? (
      <p className="collection-status" role="status" aria-live="polite">
        {props.statusMessage}
      </p>
    ) : null}
    {props.items.length === 0 ? (
      <p className="empty-state">まだ保存されたTシャツはありません。</p>
    ) : (
      <ul className="collection-list">
        {props.items.map((item) => (
          <li className="collection-item" key={item.id}>
            {item.images.front?.imageUrl ? (
              <img
                src={item.images.front.imageUrl}
                alt={`${item.name}の表面`}
              />
            ) : null}
          </li>
        ))}
      </ul>
    )}
  </section>
);
